import dynamic from 'next/dynamic';
import { AspectRatio, Flex, Box } from '@chakra-ui/react';
import { useForestExpert } from '../../lib/hooks.context';
import Teaser from '../Teaser';
import { ForestExpertProps } from '../../types';

const ForestExpertSearch = dynamic(() => import('../ForestExpertSearch'), {
  ssr: false,
});
const Image = dynamic(() => import('../Image'));
const PersonTeaser = dynamic(() => import('../PersonTeaser'));

const paddingProps = {
  p: 8,
  px: [8, 8, 8, 8, '6%'],
};

const leftWrapProps = {
  bg: 'forestExpertAltBackgroundColor',
  alignItems: 'center',
  justifyContent: 'center',
  width: [null, null, '50%'],
};

const ForestExpert = ({ title, content, image }: ForestExpertProps) => {
  const { forestExpert } = useForestExpert();

  return (
    <Box
      display={[null, null, 'flex']}
      alignItems="stretch"
      flexDirection="row-reverse"
      bg="forestExpertBackgroundColor"
      as="section"
      pos="relative"
      width="100%"
      minHeight={[null, null, '350px']}
      borderRadius="lg"
      {...(forestExpert ? { overflow: 'hidden' } : null)}
    >
      <Flex
        {...leftWrapProps}
        {...(forestExpert ? paddingProps : { borderRadius: 'lg' })}
      >
        {forestExpert ? (
          <PersonTeaser {...forestExpert} width="100%" />
        ) : (
          <AspectRatio
            ratio={[343 / 253, 657 / 420]}
            height={[null, '100%']}
            flex="0 0 100%"
          >
            <Image
              src={image?.src}
              alt={image?.alt || ''}
              layout="fill"
              useUnoptimizedImage
              borderTopRightRadius="lg"
              borderTopLeftRadius={['lg', 'lg', 0]}
              borderBottomRightRadius={[null, null, 'lg']}
              noRounding
              imgHeight="100%"
            />
          </AspectRatio>
        )}
      </Flex>
      <Teaser
        heading={{ title: title || '', style: 'h2', importance: 'h2' }}
        text={content || ''}
        display="flex"
        flexDirection="column"
        justifyContent="center"
        width={[null, null, '50%']}
        textStyle="md"
        {...paddingProps}
      >
        <ForestExpertSearch allowReset />
      </Teaser>
    </Box>
  );
};

export default ForestExpert;
